import { Field } from 'formik';
import { SttDatePicker } from '@stt-componentes/core';
import { DATA_EXAME_DE} from '../fieldNames';

const DataInicialExame = ({ strings }) => {
    return (
        <Field name={DATA_EXAME_DE}>
            {({
                field: { name, value, },
                form: { setFieldValue, setFieldError, setFieldTouched },
                meta
            }) => {
                let erroAtual = meta.error;
                return (
                    <SttDatePicker
                        label={strings.dataInicialExame}
                        inputprops={{
                            name: name,
                            inputMode: 'numeric'
                        }}
                        disableFuture
                        maxDate={new Date()}
                        error={meta.touched && meta.error ? true : false}
                        onError={error => {
                            if (error && error !== erroAtual) {
                                setFieldError(DATA_EXAME_DE, error);
                            }
                        }}
                        value={value}
                        onBlur={() => {
                            setFieldTouched(DATA_EXAME_DE, true);
                        }}
                        helperText={meta.touched && meta.error ? meta.error : undefined}
                        onChange={date => setFieldValue(DATA_EXAME_DE, date, true)}
                        onClose={() => setFieldTouched(DATA_EXAME_DE, true)}
                    />
                );
            }}
        </Field>
    )
}

export default DataInicialExame;